<template>
  <div class="container my-1">
    <div :v-if="mensagemSucesso" v-for="i in mensagemSucesso" :key="i">
      <p>
        <b-alert show variant="success" dismissible>{{ i }}</b-alert>
      </p>
    </div>
    <div :v-if="mensagemErro" v-for="i in mensagemErro" :key="i">
      <p>
        <b-alert show variant="danger" dismissible>
          <b-icon variant="danger" icon="x-circle-fill" />
          {{ i }}
        </b-alert>
      </p>
    </div>
    <div v-if="mostrarMensagemDebitosInexistentes" class="pb-1">
      <p>
        <b-alert show variant="warning" dismissible>
          <b-icon variant="warning" icon="exclamation-diamond-fill" />
          Não existe(m) débito(s) para esta pesquisa. Solicite a CND (certidão
          negativa de débitos) clicando
          <a href="http://cndonline.siatu.pbh.gov.br/CNDOnline" target="_blank">aqui</a>.
        </b-alert>
      </p>
    </div>
    <p></p>
    <div>
      <div style="text-align: center">
        <loading :active.sync="carregando" :is-full-page="true"></loading>
      </div>
      <div class="mt-0">
        <!-- ABA DADOS GERAIS -->
        <form @submit.prevent>
          <h2 class="title">Relatório de débito(s) do DRAM</h2>
          <b-card>
            <span class="title h5" title="Relatório de débitos DRAM.">
              Dados do DRAM
            </span>
            <b-row class="mb-4"> </b-row>
            <b-row class="mb-0">
              <b-col sm="2" md="2"> </b-col>
              <b-col sm="2" md="2" lg="1" align-self="center">
                <label for="cpf" class="pb-3">Número</label>
              </b-col>
              <b-col sm="8" md="4" align-self="start">
                <b-input-group class="mt-0 mb-0">
                  <b-form-input id="numeroDram" type="search" @keyup="preencheNumeroDram()" v-mask="['##.##.#######.##']"
                    v-model="dadosDRAM.numeroDram" placeholder="Informe o número do DRAM">
                  </b-form-input>
                </b-input-group>
                <small id="numeroDramMsg" class="form-text" :class="erroValidacaoIdentificador">
                  {{ mensagemValidacaoIdentificador }}
                </small>
              </b-col>
            </b-row>

            <b-row class="mr-2 float-right">
              <b-button variant="secondary" class="float-right" @click="() => limparCampos()">
                Limpar
              </b-button>
              <div v-if="exibeBtnPesquisar">
                <b-button variant="primary" class="ml-3 mr-3 float-right" :disabled="dadosDRAM.numeroDram.length < 16"
                  @click.prevent="() => pesquisar()">
                  Pesquisar
                </b-button>
              </div>
              <div v-else>
                <b-button variant="success" class="ml-3 mr-3 float-right" :disabled="dadosDRAM.numeroDram.length < 16"
                  @click.prevent="() => gerarRelatorio(dadosDRAM.numeroDram)">
                  Gerar relatório
                </b-button>
              </div>
            </b-row>
          </b-card>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import constantes from "../constants/index";
import normalizaMensagemApi from "../helpers/normalizaMensagemApi";

export default {
  components: {
    loading,
  },
  directives: {
    mask,
  },
  data() {
    return {
      exibeBtnPesquisar: true,
      carregando: false,
      origemAcesso: "",
      userName: "",
      origemNome: "",
      mensagemSucesso: [],
      mensagemErro: [],
      mostrarMensagemDebitosInexistentes: false,
      erroValidacaoIdentificador: "",
      mensagemValidacaoIdentificador: "",

      dadosDRAM: {
        numeroDram: "",
      },

      informacaoDram: {
        idDram: "",
      },

      tokens: {
        L: {
          pattern: /[A-Za-z ]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
      },
    };
  },
  methods: {
    preencheNumeroDram: function () {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      let tam = 0;
      let mensErro = "";
      let textColor = "";
      let opcao = "";
      this.exibeBtnPesquisar = true;
      if (this.dadosDRAM.numeroDram.length > 0) {
        //numero do DRAM
        tam = 16;
        opcao = "número do DRAM";
      }
      mensErro =
        this.dadosDRAM.numeroDram.length >= tam
          ? opcao + " digitado(a) é válido(a)"
          : opcao + " digitado(a) está incompleto(a)";
      textColor =
        this.dadosDRAM.numeroDram.length >= tam
          ? "text-success"
          : "text-danger";
      this.erroValidacaoIdentificador = textColor;
      this.mensagemValidacaoIdentificador = mensErro;
    },

    reinicializaIdentificador: function () {
      this.dadosDRAM.numeroDram = "";
      this.mensagemValidacaoIdentificador = "";
      //numero do DRAM
      this.dadosDRAM.numeroDram = "";
      this.mascaraNumeroDram = {};
      this.focusInput("numeroDram");
    },

    focusInput: function (campo) {
      document.getElementById(campo).focus();
    },

    limparCampos: function () {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      this.exibeBtnPesquisar = true;
      this.reinicializaIdentificador();
    },

    pesquisar: async function () {
      this.mensagemErro = [];
      this.mensagemSucesso = [];

      this.dadosDRAM.numeroDram = this.dadosDRAM.numeroDram.replace(
        /[^\d| |\w]+/g,
        ""
      );
      const pNumeroDram = this.dadosDRAM.numeroDram.substring(0, 11);
      this.carregando = true;

      await this.$axios
        .post(this.$env.url_backend + constantes.pesquisarDram, {
          numeroDram: pNumeroDram,
        })
        .then((response) => {
          if (response.data.length === 0) {
            this.limparCampos();

            this.mensagemErro.push(
              "Não existe dados para o número de DRAM informado."
            );
            window.scrollTo(0, 0);
          } else {
            const retorno = response.data;
            let idDram = retorno[0].ID_GUIA;
            this.informacaoDram.idDram = idDram;
            this.exibeBtnPesquisar = false;
          }
          this.carregando = false;
        })
        .catch((err) => {
          this.limparCampos();

          this.carregando = false;
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },

    downloadArquivo: async function (pathurl) {
      window.open(pathurl)

    },

    gerarRelatorio: async function (numeroDram) {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      this.carregando = true;
      const pNumeroDram = numeroDram.replace(/[^\d| |\w]+/g, "");
      await this.$axios
        .post(this.$env.url_backend + constantes.retornaRelatorioDram, {
          numeroDram: pNumeroDram,
        })
        .then((response) => {
          const retorno = response.data;
          if (retorno != "") {
            const url = retorno;
            this.mensagemSucesso.push("Relatório gerado com sucesso.");
            this.downloadArquivo(url, "emissaoRelatorioDRAM");
            this.carregando = false;
          } else {
            this.mensagemErro.push(
              "Houve um erro ao gerar o relatório do DRAM."
            );
          }
          this.carregando = false;
          this.exibeBtnPesquisar = true;
          this.reinicializaIdentificador();
        })
        .catch((err) => {
          this.carregando = false;
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(err);
          this.mensagemParcelamento.push(mensagem);
        });
    },
  },

  async beforeMount() { },

  async mounted() {
    this.focusInput("numeroDram");
  },
};
</script>    
